import React, { useEffect } from 'react'
const DocumentTitle = function ({ productName }) {
  useEffect(() => {
    document.title = productName
  })

  return <></>
}

export default DocumentTitle
